<ng-container *ngFor="let submitterPerStep of submittersPerStep$ | async">
  <div class="step-icon-sm">
    <div
      class="step-icon glyphicon glyphicon-refresh"
      *ngIf="submitterPerStep.step.step_type === 'Review'"
    ></div>
    <div class="step-letter">{{ submitterPerStep.step.ordinal_letter }}</div>
  </div>
  <span class="step-names">{{ submitterPerStep.submitter.full_name }}</span>
</ng-container>
